// src/screens/customer/auth/ForgotPassword.jsx

import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Mail, ArrowLeft } from "lucide-react";
import axios from "axios";
import AppContext from "../../../context/AppContext";
import "../../../assets/css/customer/forgetPassword/ForgotPassword.css";

export default function ForgotPassword() {
  const { baseUrl, RegExpChecker } = useContext(AppContext);
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSendOtp = () => {
    const emailErr = RegExpChecker("email", email);
    const hasErrors = Object.values(emailErr).some((msg) => msg !== "");
    if (hasErrors) {
      setErrors(emailErr);
      return;
    }

    setErrors({});
    setIsSubmitting(true);

    const formData = new FormData();
    formData.append("email", email);

    axios
      .post(`${baseUrl}/customer/forgot-password/sendOtp`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        console.log(response.data);
        setIsSubmitting(false);
        if (response.data.success) {
          navigate("/forget-password/verify-otp", { state: { email } });
        } else {
          setErrors({
            general:
              response.data.message ||
              "Something went wrong. Please try again.",
          });
        }
      })
      .catch((error) => {
        setIsSubmitting(false);
        setErrors({
          general:
            error.response?.data?.message ||
            "Something went wrong. Please try again.",
        });
      });
  };

  return (
    <div className="fp-page">
      <div className="fp-card">
        <button
          className="fp-back-arrow"
          onClick={() => navigate(-1)}
          aria-label="Go back"
        >
          <ArrowLeft size={18} />
        </button>

        <div className="fp-header">
          <h2 className="fp-title">Forgot password?</h2>
          <p className="fp-subtitle">
            Enter your email and we'll send you a 6-digit code
          </p>
        </div>

        <div className="fp-form-body">
          {errors.general && (
            <div className="fp-general-error">⚠ {errors.general}</div>
          )}

          <div className="fp-field">
            <label className="fp-label" htmlFor="fp-email">
              Email
            </label>
            <div className="fp-input-wrap">
              <span className="fp-input-icon">
                <Mail size={16} />
              </span>
              <input
                id="fp-email"
                type="email"
                className={`fp-input${errors.email ? " fp-input-error" : ""}`}
                placeholder="you@example.com"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setErrors(RegExpChecker("email", e.target.value));
                }}
                autoComplete="email"
              />
            </div>
            {errors.email && (
              <span className="fp-error-msg">⚠ {errors.email}</span>
            )}
          </div>

          <button
            className="fp-submit-btn"
            type="button"
            onClick={handleSendOtp}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Sending…" : "Send OTP"}
          </button>
        </div>
      </div>
    </div>
  );
}
